/* @flow */

import * as React from 'react';

import './signup-image.module.css';

export function SignupImage() {
    return (
        <div styleName='container'>
            <img src='/include/images/auth/signup-page-illustration.svg' alt='time-saving stats' />
        </div>
    );
}
